export const DocumentSourceEnum = {
  MESH: {
    value: 'MESH',
    displayName: 'NHS MESH',
    description: 'Received via NHS MESH',
  },
  EMAIL: {
    value: 'EMAIL',
    displayName: 'Email',
    description: 'Received via email forwarding',
  },
  MANUAL: {
    value: 'MANUAL',
    displayName: 'Manual Upload',
    description: 'Uploaded manually in MedPrompt',
  },
};

export function resolveDocumentSource(doc) {
  if (doc?.senderMeshMailboxId) return DocumentSourceEnum.MESH.value;
  if (doc?.senderEmail) return DocumentSourceEnum.EMAIL.value;
  return DocumentSourceEnum.MANUAL.value;
}
